<template>
    <md-table-cell>
        <md-field>
            <md-select v-model="filterValue" md-dense>
                <md-option value>-</md-option>
                <md-option :value=this.controlObject.success.value>{{this.controlObject.success.label}}</md-option>
                <md-option :value=this.controlObject.danger.value>{{this.controlObject.danger.label}}</md-option>
                <md-option :value=this.controlObject.info.value>{{this.controlObject.info.label}}</md-option>
            </md-select>
        </md-field>
    </md-table-cell>
</template>

<script>
import IndexTableFilter from "@/new/components/Index/IndexTableFilter";
import ActiveIndexTypeEnum from "@/enums/ActiveIndexTypeEnum";

    export default {
        name: "IndexTableFilterTripleState",
        mixins: [IndexTableFilter],
        data() {
            return {
                controlObject: {
                    success: ActiveIndexTypeEnum.SUCCESS,
                    danger: ActiveIndexTypeEnum.DANGER,
                    info: ActiveIndexTypeEnum.INFO,
                }
            }
        }
    }
</script>

<style scoped>

</style>